import apiClient from './_client';

export default {
    me() {
        return apiClient.get('user/me');
    },
    updateProfile(profile) {
        return apiClient.put('user/me', profile);
    },
    getCheckoutSession(callback_url) {
        return apiClient.get('user/checkout_session', {callback_url});
    },
    deletePaymentMethod(paymentMethod) {
        return apiClient.delete('user/payment_methods/' + paymentMethod.id);
    },
    loadPaymentMethods() {
        return apiClient.get('user/payment_methods');
    },
}